import React from 'react';
import { getImageSrc } from '../../../util';

type Props = {
  className?: string;
};

export const AboutVision: React.FC<Props> = props => {
  return (
    <>
      <div className={`${props.className}`}>
        <div className={'flex '}>
          <div
            className={
              'grid gap-y-6 grid-cols-1 md:grid-cols-8 md:gap-x-6 md:items-center'
            }
          >
            <div
              className={
                'row-start-2 md:row-start-1 md:col-start-5 md:col-span-4 md:ml-6 lg:ml-16 2xl:ml-20 xl:ml-20'
              }
            >
              <div>
                <p className="mt-2 text-2xl font-semibold  text-gray-900 sm:text-3xl lg:text-4xl ">
                  <span className="block inline text-gray-900">
                    Our vision is to run this company
                    <span className={'block  inline text-primary-600'}>
                      {' '}
                      like an owner runs their restaurant.
                    </span>
                  </span>
                </p>
                <p className="text-lg  sm:text-lg text-left md:text-lg  text-gray-900 mt-4 xl:mt-6">
                  That starts with taking care of our team. It means taking
                  pride in what we serve. It means providing our partners the
                  same level of service managers instill in their staff. It
                  means connecting a community of people who love food as much
                  as they love each other.
                </p>

                <div className="mt-10 sm:mt-12 w-1/10  justify-start">
                  <a
                    href="/refer-restaurants#referral_form_container"
                    className="items-center justify-start px-6 py-2 border border-transparent text-base font-medium rounded-full text-white bg-primary-600 hover:bg-primary-700 hover:text-white"
                  >
                    Refer a restaurant
                  </a>
                </div>
              </div>
            </div>
            <div
              className={`bg-blue-200 w-full sm:w-full mx-auto md:mx-0  rounded-xl shadow-md ${'md:col-start-1 row-start-1 md:col-span-4'}`}
            >
              <div className={''}>
                <picture className="lazyload">
                  <source
                    srcSet={getImageSrc('TPPFam.webp')}
                    type="image/webp"
                  />
                  <source
                    srcSet={getImageSrc('TPPFam.jpg')}
                    type="image/jpeg"
                  />
                  <img
                    className={'rounded-xl shadow-lg lazyload'}
                    data-src={getImageSrc('TPPFam.webp')}
                    alt={'partner photo'}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
